import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { GiftCardOrderSalesModel, GiftCardVirtualsModel } from "src/app/models/gifcardVirtual.model";
import { saveAs } from 'file-saver';
import { ExcelService } from 'src/app/services/excel.service';
import { AuthService } from 'src/app/services/auth.service';
import { timer } from 'rxjs';
import { Subscription } from 'rxjs';
import { TraceService } from 'src/app/services/trace.service';
import { OrderSalesStep4Component } from '../ordersales-step4/ordersales-step4.component';
import { ParameterModel } from 'src/app/models/parameter.model';
import { ParameterService } from 'src/app/services/parameter.service';

@Component({
  selector: 'app-ordersales-step4-list',
  templateUrl: './ordersales-step4-list.component.html',
  styleUrls: ['./ordersales-step4-list.component.css']
})
export class OrderSalesStep4ListComponent implements OnInit, OnDestroy {

  constructor(private giftCardService: GifcardVirtualService,
    private messageService: MessageService,
    private excelService: ExcelService,
    private authService: AuthService,
    private parameterService: ParameterService) { }

  private subscription: Subscription = new Subscription();
  totalOrderSales: number;
  dlgOrderSales: boolean;
  dlgEmailFails: boolean;
  dlgUpdateEmail: boolean;
  itemOrderSales;
  itemSendFails;
  selectOrderSales: GiftCardOrderSalesModel;
  datasourceTablaOrderSales: GiftCardOrderSalesModel[] = [];
  colsTablaOrderSales: any[];
  colsTablaEmailFails: any[];
  dataDetail: {};
  datasourceGiftCardVirtual: GiftCardVirtualsModel[] = [];
  loading: boolean = false;
  currentUser: string;
  observation: string;
  dlgActivation: boolean = false;
  @ViewChild('step4component', { static: false }) step4Component: OrderSalesStep4Component;
  permLow: number = 0;
  permMedium: number = 0;
  permHigh: number = 0;
  datasourceParameters: ParameterModel[] = [];

  ngOnInit() {
    this.currentUser = this.authService.getCurrentUser();
    this.createColumnsTablaGiftCardVirtual();
    this.populateListParameters();
    //this.refreshData();
    this.populateTableOrderSales();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  refreshData() {
    this.subscription.add(this.populateTableOrderSales());
    this.subscription.add(this.subscribeToData());
  }

  subscribeToData() {
    this.subscription.add(console.log("refreshdata"));
    this.subscription.add(
      timer(60000).subscribe(() => this.refreshData())
    );
  }

  createColumnsTablaGiftCardVirtual() {
    this.colsTablaOrderSales = [
      { field: 'NRO_ORDEN_COMPRA', header: 'Nro. Ord. Compra', width: '8%', align: 'center' },
      { field: 'DESC_MODELO_GIFT_CARD', header: 'Modelo Giftcard', width: '10%', align: 'center' },
      { field: 'NRORUC_CLIENTE', header: 'RUC', width: '7%', align: 'center' },
      { field: 'RAZSOC_CLIENTE', header: 'Razón Social', width: '25%', align: 'center' },      
      { field: 'IMP_ORDEN_COMPRA', header: 'Importe', width: '8%', align: 'center' },
      { field: 'CAN_ORDEN_COMPRA', header: 'Cant.', width: '6%', align: 'center' },
      { field: 'CREATIONUSER', header: 'Usuario Distribuidor', width: '6%', align: 'center' },
      { field: 'CREATIONDATE', header: 'Fecha Distribución', width: '6%', align: 'center' },
      { field: 'PERMANENCIA', header: 'Días Perman.', width: '6%', align: 'center' }
    ];
  }

  populateTableOrderSales() {
    this.loading = true;
    let params = {
      "p_flag_activo": 8,
      "p_isfacturado":"N"
    }

    this.giftCardService.GetOrderSalesByStatus(params).subscribe(
      (response: GiftCardOrderSalesModel[]) => {
        this.datasourceTablaOrderSales = response;
        this.totalOrderSales = this.datasourceTablaOrderSales.length;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar las ordenes de compra.' });
      }
    )
  }

  populateListParameters() {
    this.parameterService.GetGiftCardParameters().subscribe(
      (response: ParameterModel[]) => {
        this.datasourceParameters = response;
        if (this.datasourceParameters) {
          this.datasourceParameters.forEach(param => {
            if (param.KEY_PARAMETER == 'GCV_PERM_LOW')
              this.permLow = Number(param.VALUE_SHORT);
            else if (param.KEY_PARAMETER == 'GCV_PERM_MEDIUM')
              this.permMedium = Number(param.VALUE_SHORT);
            else if (param.KEY_PARAMETER == 'GCV_PERM_HIGH')
              this.permHigh = Number(param.VALUE_SHORT);
          });
        }
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar parámetros.' });
      }
    )
  }

  populateTablaGiftCardVirtual() {
    this.loading = true;
    let order = {
      "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
      "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
      "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
      "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT
    };
    this.giftCardService.GetGiftCardVirtualsNewCode(order).subscribe(
      (response: GiftCardVirtualsModel[]) => {
        this.datasourceGiftCardVirtual = response;
        this.excelService.exportAsExcelFile(this.datasourceGiftCardVirtual, 'giftcard');
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar gift card.' });
      }
    )
  }

  onShowDlgOrderSales(order: GiftCardOrderSalesModel) {
    this.itemOrderSales = order;
    this.dlgOrderSales = true;
  }

  onShowActivation(order: GiftCardOrderSalesModel) {
    this.itemOrderSales = order;
    this.dlgActivation = true;
    this.step4Component.loadParametersOrderSalesStep4(this.itemOrderSales, this.fnCloseDlgActivation);
  }

  fnCloseDlgActivation = () => {
    this.dlgActivation = false;
    this.populateTableOrderSales();
  }

  downloadIMGModel() {
    saveAs(this.itemOrderSales.IMG_MODELO_GIFT_CARD, "modelo.jpg");
  }

  downloadIMGOrder() {
    saveAs(this.itemOrderSales.IMG_ORDEN_COMPRA, "orden.jpg");
  }

  downloadIMGCotizacion() {
    saveAs(this.itemOrderSales.IMG_COTIZACION, "cotizacion.jpg");
  }

  donwloadAdicional1() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL1, "adicional.jpg");
  }

  donwloadAdicional2() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL2, "adiciona2.jpg");
  }

  donwloadAdicional3() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL3, "adiciona3.jpg");
  }
}